import React from 'react';
import { CourseNavToggle } from '@/app/providers/course-nav-toggle-provider';

export default function useCourseNavToggle() {
  return React.useContext(CourseNavToggle);
}
